import Statistic from './index';

function StatisticGuard() {
    return <Statistic />;
}

export default StatisticGuard;
